import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ArrowRight, FileStack, Zap, Workflow, Shield } from "lucide-react";

const stats = [
  {
    icon: <FileStack className="text-tasktide-teal h-7 w-7" />,
    value: '28',
    label: 'Products',
    desc: 'Across 7 categories. Email, lead gen, content, documents, voice, social, operations, and niche workflows.'
  },
  {
    icon: <Zap className="text-tasktide-purple h-7 w-7" />,
    value: '1h',
    label: 'Ship Cycle',
    desc: 'From brief to working product with backend, UI, tests, and a private GitHub repo. Every single hour.'
  },
  {
    icon: <Workflow className="text-tasktide-orange h-7 w-7" />,
    value: '100%',
    label: 'Autonomous',
    desc: 'An agent picks the next product from the queue, writes the code, runs the tests, and pushes to GitHub. No human bottleneck.'
  },
  {
    icon: <Shield className="text-emerald-400 h-7 w-7" />,
    value: '0',
    label: 'Cloud APIs',
    desc: 'All AI runs locally on your machine. Your data never leaves. No subscriptions to third-party inference services.'
  }
];

const ManifestSection = () => {
  return (
    <section className="relative">
      <div className="absolute inset-0 bg-gradient-to-b from-dark-500 via-dark-400 to-dark-500" />
      <div className="section-container relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
            One Tool. One Job. Done Right.
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            We do not build platforms. We build single-purpose tools that solve one problem completely. 
            Each ships with a working backend, a clean UI, and real tests. 
            You download the source, run it locally, and own it.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="glass-card p-6 rounded-xl hover:-translate-y-1 transition-all duration-300 border border-white/5"
            >
              <div className="mb-4">{stat.icon}</div>
              <div className="text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-sm font-medium text-tasktide-teal mb-3">{stat.label}</div>
              <p className="text-gray-400 text-sm leading-relaxed">{stat.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button asChild className="bg-gradient-to-r from-tasktide-teal to-tasktide-blue hover:shadow-lg hover:shadow-tasktide-teal/20 transition-all duration-300">
            <Link to="/projects">
              See the Full Catalog <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ManifestSection;